module.exports = __webpack_public_path__ + "media/index1.ed1b0431.webm";